import { Gym, IAlertData } from 'fitbeat.models';
import { AlertEntry } from '../../entities/alert';
import { IAlertRepository } from '../../persistence';
import { IAlertsManager } from './ialertsmanager';

export class AlertsManager implements IAlertsManager {
  constructor(private alertRepository: IAlertRepository) { }

  public createAlert(alert: IAlertData): Promise<AlertEntry> {
    return this.alertRepository.add(alert);
  }

  public async getAllUnresolvedAlerts(
    gym: Gym,
    lastAlertCreatedAt?: Date,
  ): Promise<AlertEntry[]> {
    const alerts = await this.alertRepository.getAllActive(gym);
    this.determineIfAlertsAreUnseen(alerts, lastAlertCreatedAt);
    return alerts;
  }

  public async markAsResolve(uid: string): Promise<AlertEntry> {
    const alert = await this.alertRepository.get(uid);
    if (!alert) {
      throw new Error(`No alert found with uid ${uid}`);
    }
    alert.resolved = true;
    return this.alertRepository.update(alert);
  }

  public async getAllAlerts(gym: Gym): Promise<AlertEntry[]> {
    return this.alertRepository.getAll(gym);
  }

  private determineIfAlertsAreUnseen(alerts: AlertEntry[], lastAlertCreatedAt?: Date) {
    return alerts.map((alert: AlertEntry) => {
      if (lastAlertCreatedAt) {
        alert.newSinceLastSeen = alert.createdAt.getTime() > lastAlertCreatedAt.getTime();
      } else {
        alert.newSinceLastSeen = true;
      }
      return alert;
    });
  }
}
